import * as React from "react";

// Trigger handler on keydown event
export const useKeyHandler = (keyCode: string, handler: () => void): void => {
  const onKeydownHandlerRef = React.useRef(
    (event: KeyboardEvent) => event.key === keyCode && handler()
  );

  React.useEffect(() => {
    const onKeydownHandler = onKeydownHandlerRef.current;
    document.addEventListener("keydown", onKeydownHandler);

    return () => {
      onKeydownHandler &&
        document.removeEventListener("keydown", onKeydownHandler);
    };
  }, [onKeydownHandlerRef]);
};
